import React from 'react';
import {Table, type TableProps} from "antd";

const actionBarStyle: React.CSSProperties = { paddingBottom: 12, display: 'flex', justifyContent: 'right' };

type Props = {
    list?: any[]
}

const CarProdTable: React.FC<Props> = (props) => {
    const { list } = props
    const columns: TableProps<any>['columns'] = [
        { title: '门店', dataIndex: 'store_name', key: 'store_name' },
        { title: '车型名称', key: 'action', render: (_, record) => <>
                {`${record.veh_brand_name} · ${record.veh_series_name} · ${record.veh_model_name} `}
            </> },
    ];

    return (
        <Table
            columns={columns}
            dataSource={list}
            rowKey={cols => cols.id}
            pagination={false}
        />
    );
};

export default CarProdTable;
